<lib-slide-toggle
    [checked]="bindingProperty"
    (checkedChange)="onToggleChanged($event)"
    [isReadOnly]="isReadOnly"
></lib-slide-toggle>
